import { Box, Paper, Typography } from '@mui/material'
import shared from '@/components/Settings/settingsShared.module.scss'

export function ConnectionsDirectoryListEmpty() {
  return (
    <Paper elevation={0} className={shared.connectionsPaper}>
      <Box className={shared.connectionsEmpty}>
        <Typography variant="body2" className={shared.connectionsEmptyTitle}>
          No applications connected yet
        </Typography>
        <Typography variant="body2" className={shared.connectionsEmptyBody}>
          Connect Gmail, Calendar, or other apps from a chat thread (connect card) or open Briefing and choose
          Apps. Completed connections appear here for this browser session until a directory API is available.
        </Typography>
      </Box>
    </Paper>
  )
}

export function ConnectionsDirectorySearchEmpty() {
  return (
    <Paper elevation={0} className={shared.connectionsPaper}>
      <Box className={shared.connectionsNoHits}>
        <Typography variant="body2" className={shared.connectionsNoHitsText}>
          No apps match your search.
        </Typography>
      </Box>
    </Paper>
  )
}
